import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ti-step-number-and-circles',
  templateUrl: './step-number-and-circles.component.html',
  styleUrls: ['./step-number-and-circles.component.sass'],
})
export class StepNumberAndCirclesComponent {
  public readonly strings = tiStrings.shared.simpleComponents.stepNumberAndCircles;

  @Input() currentStep: number;
  @Input() totalSteps: number;

  getStepsArray() {
    return Array(this.totalSteps);
  }
}
